import PropTypes from "prop-types";

import { useTranslation } from "react-i18next";

function StrategicAnalysisMobile({ config }) {
  const { t } = useTranslation();
  const { cards } = config.overview;

  return (
    <iframe
      width={"100%"}
      height={"100%"}
      src="https://mtrix-padsales-main.mtrix.com.br"
    ></iframe>
  );
}

StrategicAnalysisMobile.defaultProps = {
  app: null,
  config: {},
};

StrategicAnalysisMobile.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default StrategicAnalysisMobile;
